<template>
    <div class="container-sign">
        <div class="sign-top">
            <div class="top-left">
                <div class="top-icon"></div>
                <div>
                    <div class="top-tit">限时签到福利</div>
                    <div class="top-desc">
                        最多可得<span style="color: #ff5a5a">{{ signData.maxScore }}</span
                        >活力值
                    </div>
                </div>
            </div>
            <div class="top-right">
                <span v-if="isTaskEnd">任务已完成</span>
                <span v-else>
                    任务结束剩余<span class="endtime" style="font-size: 9px">{{
                        signData.taskEndInDays
                    }}</span
                    >天
                </span>
            </div>
        </div>
        <div class="gold-area">
            <div
                class="gold-item"
                v-for="(item, index) in signData.taskStatusInfoList"
                :key="index"
            >
                <div class="item-top" @click="takeSignInTask(item)">
                    <div :class="['goldicon', goldIconStyle(index, item)]">
                        {{ item.status !== 2 ? item.score : '' }}
                    </div>
                    <div
                        :class="
                            signData.currentDay === item.day && item.status === 0
                                ? 'curr-day'
                                : 'sign-day'
                        "
                    >
                        {{ signDayText(item) }}
                    </div>
                </div>
                <div class="line-sty" v-if="index < signData.taskStatusInfoList.length - 1"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['signData', 'switch3DCat'],
    data() {
        return {
            isTaskEnd: false
        };
    },
    watch: {
        signData: {
            deep: true,
            immediate: true,
            handler: function(newV) {
                if (newV) {
                    newV.taskStatusInfoList.forEach(item => {
                        if (item.day === 7) {
                            this.isTaskEnd = item.status === 2 ? true : false;
                        }
                    });
                }
            }
        }
    },
    methods: {
        goldIconStyle(index, item) {
            if (item.status === 2) {
                return this.switch3DCat ? 'sign-done-gold' : 'sign-done-cat';
            }
            if ([2, 4, 6].indexOf(index) > -1) {
                return this.switch3DCat ? 'sign-m-gold' : 'sign-m-cat';
            } else {
                return this.switch3DCat ? 'sign-gold' : 'sign-cat';
            }
        },
        signDayText(item) {
            if (this.signData.currentDay === item.day && item.status === 0) {
                return '签到';
            }
            return `${item.day}天`;
        },
        async takeSignInTask(item, cb) {
            if (item.status === 0 && item.day === this.signData.currentDay) {
                const { Result } = await this.$http.takeSignInTask({ day: item.day });
                if (Result === 200) {
                    this.$emit('signTaskSuccess');
                    cb && cb();
                    if (item.day < 7) {
                        this.$toast({
                            message: `签到成功，明日可得${
                                this.signData.taskStatusInfoList[item.day].score
                            }活力值`,
                            duration: 2000
                        });
                    } else {
                        this.$toast({ message: '恭喜您完成签到任务', duration: 2000 });
                    }
                } else if (Result === 40721) {
                    this.$toast({ message: '不可领取该任务', duration: 2000 });
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/signIcon';
.container-sign {
    width: 339px;
    height: 170px;
    background: #ffffff;
    box-shadow: 0px 1px 8px 0px rgba(19, 66, 137, 0.09);
    border-radius: 12px;
    margin-bottom: 20px;
    margin-top: 20px;
    .sign-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 18px 15px 0;
        .top-left {
            display: flex;
            flex-direction: row;
            align-items: center;
            .top-icon {
                width: 38px;
                height: 38px;
                background-size: 100% 100%;
                background-image: url('@{asserts}/sign-pop-icon@2x.png');
                margin-right: 9px;
            }
            .top-tit {
                color: #002a3c;
                font-size: 15px;
                // font-family: fzlt_bold;
                font-weight: bold;
            }
            .top-desc {
                margin-top: 7px;
                color: #002a3c;
                font-size: 12px;
                // font-family: fzlt;
            }
        }
        .top-right {
            margin-top: -16px;
            color: #a5a5a5;
            font-size: 11px;
        }
        .endtime {
            border-radius: 2px;
            margin: 0 2px;
            padding: 1px 2px 0;
            color: #fff;
            background-color: #fc7e45;
            // font-family: fzlt_bold;
            font-weight: bold;
            text-align: center;
        }
    }
    .gold-area {
        // margin-top: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        // align-items: center;
        width: 309px;
        height: 84px;
        background: #fdf8f8;
        border-radius: 4px;
        margin: 16px 15px 0;
        padding: 17px 14px 0 4px;
        .gold-item {
            display: flex;
            flex-direction: row;
            .item-top {
                display: flex;
                flex-direction: column;
                align-items: center;
                .goldicon {
                    width: 29px;
                    height: 26px;
                    background-size: 100% 100%;
                    font-size: 10px;
                    text-align: center;
                    line-height: 24px;
                    // font-family: fzlt_bold;
                    font-weight: bold;
                    z-index: 1;
                }
                .sign-done-gold {
                    color: #df5d1f;
                    background-image: url('@{asserts}/sign-done-gold@2x.png');
                }
                .sign-done-cat {
                    color: #fd8e00;
                    background-image: url('@{asserts}/sign-done-cat@2x.png');
                }
                .sign-gold {
                    color: #df5d1f;
                    background-image: url('@{asserts}/gold-s-sign@2x.png');
                }
                .sign-m-gold {
                    color: #df5d1f;
                    background-image: url('@{asserts}/gold-m-sign@2x.png');
                }
                .sign-cat {
                    color: #fd8e00;
                    background-image: url('@{asserts}/cat-s-sign@2x.png');
                }
                .sign-m-cat {
                    color: #fd8e00;
                    background-image: url('@{asserts}/cat-m-sign@2x.png');
                }
                .sign-day {
                    margin-top: 8px;
                    color: #eaccb9;
                    font-size: 12px;
                    // font-family: fzlt_bold;
                    font-weight: bold;
                    text-align: center;
                    white-space: nowrap;
                }
                .curr-day {
                    margin-top: 3px;
                    width: 32px;
                    height: 17px;
                    background-size: 100% 100%;
                    background-image: url('@{asserts}/badge-sign@2x.png');
                    color: #fff;
                    font-size: 10px;
                    // font-family: fzlt_bold;
                    font-weight: bold;
                    text-align: center;
                    line-height: 20px;
                }
            }
            .line-sty {
                margin: 11px -4px 0;
                background: #fae1d1;
                width: 22px;
                height: 1px;
            }
        }
    }
}
</style>